enum DeliveryOptionType {
  BASIC,
  FIXED,
}

export default DeliveryOptionType;
